import {
  Box,
  TextField,
  InputAdornment,
  Grid,
  Checkbox,
  FormControlLabel,
  Card,
  CardContent,
} from "@mui/material";
import Iconify from "../iconify";

export default function TransactionsFilters({
  searchQuery,
  setSearchQuery,
  selectedTypes,
  setSelectedTypes,
  transactionTypes,
}) {
  const handleTypeChange = (type, checked) => {
    setSelectedTypes((prev) =>
      checked ? [...prev, type] : prev.filter((t) => t !== type)
    );
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <TextField
            margin="dense"
            label="Search"
            type="text"
            variant="standard"
            value={searchQuery}
            onInput={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Iconify icon={"eva:search-outline"} />
                </InputAdornment>
              ),
            }}
            sx={{ width: 314 }}
          />

          <Grid container spacing={2}>
            {transactionTypes.map((type) => (
              <Grid item xs={6} sm={4} md={2} key={type.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedTypes.includes(type.id)}
                      onChange={(e) =>
                        handleTypeChange(type.id, e.target.checked)
                      }
                    />
                  }
                  label={type.label}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
}
